import { render, staticRenderFns } from "./Fabric.vue?vue&type=template&id=4c60c32d&scoped=true"
import script from "./Fabric.vue?vue&type=script&lang=js"
export * from "./Fabric.vue?vue&type=script&lang=js"
import style0 from "./Fabric.vue?vue&type=style&index=0&id=4c60c32d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c60c32d",
  null
  
)

export default component.exports